import { render, staticRenderFns } from "./CollectionsTab.vue?vue&type=template&id=38dbec6e&"
import script from "./CollectionsTab.vue?vue&type=script&lang=js&"
export * from "./CollectionsTab.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports